import {FormType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const typeField: FormType = {
	id: 0,
	parent_id: 0,
	channel: 'radio',
	name: 'type',
	label: '',
	required: true,
	options: [
		{
			amount: null,
			path: 'individual',
			title: copy?.type?.individual || 'Ik schrijf me in als individu'
		},
		{
			amount: null,
			path: 'team',
			title: copy?.type?.team || 'Ik schrijf me in als team'
		}
	]
}

export default typeField
